
export default function AppShowcase() {
  return (
    <div className="bg-[#f4f6fb]">
     <img src="/img/stunning-mobile-app.png" alt="Stunning Mobile App" className="w-full h-auto"/>
    </div>
  );
}